import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useQueryLoader } from '@sorare/core/src/hooks/graphql/useQueryLoader';
import { queryLoader } from '@sorare/core/src/lib/navigation/queryLoader';

import { RankingsPage } from '#src/pages/RankingsPage/index.tsx';

import type {
  RankingsLineupPageQuery,
  RankingsLineupPageQueryVariables,
} from './__generated__/page.graphql.ts';
import type { PageParams } from './__generated__/routeParams.ts';

const RANKINGS_LINEUP_PAGE_QUERY = gql`
  query RankingsLineupPageQuery($leaderboard: String!, $contender: String!) {
    so5 {
      so5Leaderboard(slug: $leaderboard) {
        slug
        ...RankingsPage_so5Leaderboard
      }
      so5LeaderboardContender(slug: $contender) {
        slug
        ...RankingsPage_so5LeaderboardContender
      }
    }
  }
  ${RankingsPage.fragments.so5Leaderboard}
  ${RankingsPage.fragments.so5LeaderboardContender}
` as TypedDocumentNode<
  RankingsLineupPageQuery,
  RankingsLineupPageQueryVariables
>;

export const loader = queryLoader(
  RANKINGS_LINEUP_PAGE_QUERY,
  ({ leaderboard, contender }: PageParams) => ({
    leaderboard,
    contender,
  })
);

const RankingsContenderPage = () => {
  const { data } = useQueryLoader<RankingsLineupPageQuery>();
  return (
    <RankingsPage
      so5Leaderboard={data.so5.so5Leaderboard}
      so5LeaderboardContender={data.so5.so5LeaderboardContender}
    />
  );
};

export default RankingsContenderPage;
